import { BACKGROUND_COLOR_CLASS as BACKGROUND_COLOR_CLASS$1 } from '../../tokens/token-build/js/constants/_background-color-classes.js';
import { COLOR_CLASS as COLOR_CLASS$1 } from '../../tokens/token-build/js/constants/_color-classes.js';

const COLOR_CLASS = COLOR_CLASS$1;
const BACKGROUND_COLOR_CLASS = BACKGROUND_COLOR_CLASS$1;
const getColorClass = (color) => COLOR_CLASS$1[color];
const getBackgroundColorClass = (backgroundColor) => BACKGROUND_COLOR_CLASS$1[backgroundColor];

export { BACKGROUND_COLOR_CLASS, COLOR_CLASS, getBackgroundColorClass, getColorClass };
